import { ErrorHandler, Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const errorMsg = error.message || (typeof error === 'string' ? error : JSON.stringify(error));

    // Filter out known platform/expected errors
    if (this.isSuppressedError(errorMsg)) {
      console.warn('Handling suppressed error:', errorMsg);
      return;
    }

    // Only log to console, do not inject into DOM as requested
    console.error('Global error handler caught error:', error);
  }

  private isSuppressedError(errorMsg: string): boolean {
    const suppressedErrors = [
      'plugin is not implemented on web',
      'StatusBar" plugin is not implemented on web',
      'SplashScreen" plugin is not implemented on web',
      'Camera" plugin is not implemented on web',
      'Geolocation" plugin is not implemented on web',
      'Network" plugin is not implemented on web',
      'Geolocation not supported on web browser'
    ];

    return suppressedErrors.some(error =>
      errorMsg.toLowerCase().includes(error.toLowerCase())
    );
  }
}
